import { INITIATIVE_FIELDS } from "../domain/initiativeFields";

const getDisplayField = (entry) => {
  if (entry.type === "deletion") return "Deleted";
  if (entry.field === "created") return "Created";
  if (entry.field === "archived") return "Archived";
  if (entry.field === "comment") return "Comment";
  return INITIATIVE_FIELDS[entry.field]?.label ?? entry.field;
};

// Clicking a chip cycles neutral -> include -> exclude -> neutral
// Categories marked `excludable: false` cycle neutral -> include -> neutral
export const FILTER_CATEGORIES = [
  {
    key: "product",
    label: "Product",
    getValues: (item) => item.product || [],
  },
  { key: "owner", label: "Owner", getValues: (item) => [item.owner] },
  { key: "horizon", label: "Horizon", getValues: (item) => [item.horizon] },
  {
    key: "targetPeriod",
    label: "Target Period",
    getValues: (item) => [item.targetPeriod],
  },
  { key: "status", label: "Status", getValues: (item) => [item.status] },
  {
    key: "priority",
    label: "Priority",
    getValues: (item) => [item.priority],
  },
  {
    key: "impactAreas",
    label: "Impact Areas",
    getValues: (item) => item.impactAreas || [],
  },
  {
    key: "archived",
    label: "Archived",
    getValues: (item) => (item.archived ? ["Archived"] : []),
    excludable: false,
  },
];

export const ACTIVITY_FILTER_CATEGORIES = [
  {
    key: "changedBy",
    label: "Changed By",
    getValues: (e) => [e.changedBy].filter(Boolean),
  },
  {
    key: "field",
    label: "Field",
    getValues: (e) => [getDisplayField(e)],
  },
];
